import controller from './packet.controller';
import './packet.less';

export default {
  bindings: {
    packet: '<',
    subscribed: '<?',
    forSubscribe: '<?'
  },
  controller,
  template: require('./packet.html')
};



// WEBPACK FOOTER //
// src/app/packet/packet.component.ts